import * as React from 'react';
import {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import Select from "react-select";
import {Accordion, Card, Col, Row} from "react-bootstrap";
import {listUsers, logout} from "../actions/userActions";
import { listPlayerLogDates, listPlayerLogForDate, listPlayers} from "../actions/playerActions";
import Message from "../components/Message";

const AdminScreen = ({history, language, t}) => {

    const userLogin = useSelector((state) => state.userLogin);
    const {userInfo} = userLogin;
    const dispatch = useDispatch();

    const [userOptions, setUserOptions] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    const [availableDateOptions, setAvailableDateOptions] = useState([]);
    const [selectedDate, setSelectedDate] = useState([]);
    const [playerOptions, setPlayerOptions] = useState([]);
    const [selectedPlayer, setSelectedPlayer] = useState(null);
    const userList = useSelector((state) => state.userList);
    const {loading, users, error} = userList;
    const playersList = useSelector((state) => state.playerList);
    const {
        loading: playersLoading,
        players,
        error: playersError,
    } = playersList;

    const logDates = useSelector((state) => state.playerLogDates);
    const {loading: datesLoading, dates, error: logDatesError } = logDates;

    const logForDate = useSelector((state) => state.playerLogForDate);
    const {loading: logsLoading, logs, error: logsError } = logForDate;

    const [downloadsLog, setDownloadsLog] = useState([]);
    const [playerLog, setPlayerLog] = useState([]);

    useEffect(() => {
        if (!userInfo || !userInfo.isAdmin) {
            history.push('/login');
        }
    }, [userInfo, history]);

    useEffect(() => {
        dispatch(listUsers());
    },[dispatch]);

    useEffect(()=>{
        if(users?.length > 0){
            const moddedUsers = users.map(user => {
                user.label = user.name + ' - ' + user.email + `\n(${user.folder})`;
                user.value = user.email;
                return user;
            });
            setUserOptions(moddedUsers);
        }
    }, [users])

    useEffect(()=>{
        if(error && error.includes('Not authorized')){
            dispatch(logout());
            history.push('/login');
        }
    },[error]);

    useEffect(()=>{
        if(players?.length > 0){
            const moddedPlayers = players.map(player => {
                player.label = player.name;
                player.value = player.folder;
                return player;
            });
            setPlayerOptions(moddedPlayers);
        }
    }, [players]);

    useEffect(()=>{
        if(dates?.length > 0){
           const moddedDates = dates.map(date => {
                const idk = {}
                idk.date = date;
                idk.label = date;
                idk.value = date;
                return idk;
            });
            setAvailableDateOptions(moddedDates);
        }
    }, [dates]);

    useEffect(()=>{
        if(logs !== {}){
           setDownloadsLog(logs.downloader);
           setPlayerLog(logs.player);
        }
        else {
            setDownloadsLog([]);
            setPlayerLog([]);
        }
    }, [logs]);

    const onUserChanged = (userFromSelect) => {
        setSelectedUser(userFromSelect);
        setDownloadsLog([]);
        setPlayerLog([]);
        setSelectedPlayer(null);
        setSelectedDate(null);
        setPlayerOptions([]);
        setAvailableDateOptions([]);
        dispatch(listPlayers(userFromSelect._id, 'all'));
    }

    const onPlayerChanged = (playerFromSelect) => {
        setSelectedPlayer(playerFromSelect);
        setDownloadsLog([]);
        setPlayerLog([]);
        setSelectedDate(null);
        setAvailableDateOptions([]);
        dispatch(listPlayerLogDates(playerFromSelect._id));
    }

    const onDateChanged = (dateFromSelect) => {
        setSelectedDate(dateFromSelect);
        dispatch(listPlayerLogForDate(selectedPlayer._id, dateFromSelect.date));
    }

    return (
        <>
            <h1>
                {t('logs')}
            </h1>
            <Row className='mb-3'>
                <Col><Select options={userOptions} onChange={onUserChanged} placeholder={'Felhasználó'}/></Col>
                <Col>{selectedUser !== null ? <Select options={playerOptions} onChange={onPlayerChanged} placeholder={'Lejátszó'} value={selectedPlayer}/> : null}</Col>
                <Col>{selectedUser !== null && selectedPlayer !== null ? <Select options={availableDateOptions} onChange={onDateChanged} placeholder={'Dátum'} value={selectedDate}/> : null}</Col>
            </Row>

            {error ? <Message variant='danger'>{error}</Message> : null}
            {playersError ? <Message variant='danger'>{playersError}</Message> : null}
            {logDatesError ? <Message variant='danger'>{logDatesError}</Message> : null}
            {logsError ? <Message variant='danger'>{logsError}</Message> : null}

            {selectedUser !== null && selectedPlayer !== null && selectedDate !== null && downloadsLog?.length > 0 ? <div>
                <Accordion className='mt-3'>
                    <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="0">
                            Letöltő log
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="0">
                            <Card.Body>{downloadsLog?.map((log,idx) => <div key={idx}>{log}</div>)}</Card.Body>
                        </Accordion.Collapse>
                    </Card>
                </Accordion>
            </div> : null}
            {selectedUser !== null && selectedPlayer !== null && selectedDate !== null && playerLog?.length > 0 ? <div>
                <Accordion className='mt-3'>
                    <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="0">
                            Lejátszó log
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="0">
                            <Card.Body>{playerLog?.map((log,idx) => <div key={idx}>{log}</div>)}</Card.Body>
                        </Accordion.Collapse>
                    </Card>
                </Accordion>
            </div> : null}

        </>
    );
};

export default AdminScreen;
